import React from 'react';
import ImageGeneratorBase from './ImageGeneratorBase';

interface SharepicGeneratorProps {
  backgroundUrl: string;
  backgroundName: string;
}

const SharepicGenerator: React.FC<SharepicGeneratorProps> = ({
  backgroundUrl,
  backgroundName
}) => {
  return (
    <ImageGeneratorBase
      backgroundUrl={backgroundUrl}
      backgroundName={backgroundName}
      variant="sharepic"
    />
  );
};

export default SharepicGenerator;